
<template>
  <!-- 限制管理 － 限制管理 -->
    <content-view>
        <div class="restrict pt24 pb24 pl32 pr32">
        <a-table
            bordered
            class="restrict-table"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :showHeader="false"
            :rowKey="record => record.name"
        >
            <template
            slot="limit"
            slot-scope="text, record"
            >
                <div>
                    <a-radio-group v-model="record.limit" :disabled="!record.editable">
                        <a-radio :value="false">不限制</a-radio>
                        <a-radio :value="true">限制</a-radio>
                    </a-radio-group>
                </div>
            </template>
            <template
            slot="name"
            slot-scope="text"
            >
                <div>
                    {{text}}
                </div>
            </template>
            <template
            slot="limitNum"
            slot-scope="text, record"
            >
                <div>
                    <span class="mr8">数量</span>
                    <a-input-number class="limitNum" :precision="0" :min="1" :disabled="!record.editable || !record.limit" v-model="record.limitNum" placeholder="请输入"/>
                    <span class="text-fail ml8" v-if="record.limit">{{record.name}}：{{record.limitNum}}</span>
                    <span class="text-fail ml8" v-else>不限制{{record.name.substr(0,record.name.length-2)}}</span>
                </div>
            </template>
            <template slot="operation" slot-scope="text, record, index">
                <div v-if="getBtnByAuth('restricUpdate')" class='editable-row-operations'>
                    <span v-if="record.editable">
                        <a-popconfirm title='确认保存?' @confirm="save(index)">
                            <a class="text-primary">保存</a>
                        </a-popconfirm>
                        <a-divider type="vertical" />
                        <a-popconfirm title='确认取消?' @confirm="cancel(index)">
                            <a class="text-primary">取消</a>
                        </a-popconfirm>
                    </span>
                    <span v-else>
                        <a class="text-primary" @click="edit(index)">编辑</a>
                    </span>
                </div>
            </template>
        </a-table>
        </div>
    </content-view>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    const columns = [
    {
        dataIndex: "operation",
        width: "110px",
        scopedSlots: { customRender: "operation" }
    },
    {
        dataIndex: "name",
        width: "310px",
        scopedSlots: { customRender: "name" }
    },
    {
        dataIndex: "limit",
        width: "200px",
        scopedSlots: { customRender: "limit" }

    },
    {
        dataIndex: "limitNum",
        scopedSlots: { customRender: "limitNum" }
    }
    ];
    const dataSource = [
        {operation: true, limit: false, limitNum: '', name: '每日入场人数限制', editable: false},
        {operation: true, limit: false, limitNum: '', name: '每日线上下午茶预约人数限制', editable: false},
        {operation: true, limit: false, limitNum: '', name: '每日线上入场预约人数限制', editable: false}
    ];
    export default {
        name: "restrictIndex",
        components: {},
        props: {},
        data() {
            return {
                columns,
                dataSource: dataSource,
                dataList: []
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            getDetail() {
                if(!this.shopId) return
                this.$api.restrict
                .getShopLimit({
                    params: {shopId: this.shopId}
                })
                .then(res => {
                    // dataList = [每日入场人数限制, 每日线上下午茶预约人数限制, 每日线上入场预约人数限制]
                    this.dataList = [res.dailyEntrance, res.afternoonTeaReserve, res.dailyEntranceReserve]
                    this.dataList.map((item, index) => {
                        this.dataSource[index].limit = item !== -1
                        this.dataSource[index].limitNum = item > -1 ? item : ''
                    })
                });
            },
            edit (index) {
                this.$set(this.dataSource[index],'editable',true);
            },
            save (index) {
                let values = {
                    dailyEntrance: index === 0 ? (this.dataSource[0].limit ? this.dataSource[0].limitNum : -1) : this.dataList[0],
                    afternoonTeaReserve: index === 1 ? (this.dataSource[1].limit ? this.dataSource[1].limitNum : -1) : this.dataList[1],
                    dailyEntranceReserve:  index === 2 ? (this.dataSource[2].limit ? this.dataSource[2].limitNum : -1) : this.dataList[2],
                }
                this.$api.restrict
                .shopLimit({
                    body: {
                        ...values,
                        shopId: this.shopId,
                    }
                })
                .then(res => {
                    this.$message.success('操作成功', 2)
                });
                this.$set(this.dataSource[index],'editable',false);
            },
            cancel (index) {
                this.$set(this.dataSource[index],'editable',false);
                this.dataSource[index].limit = this.dataList[index] !== -1
                this.dataSource[index].limitNum = this.dataList[index] > -1 ? item : ''
            }
        },
        created() {},
        mounted() {
            this.getDetail()
        },
        watch: {
            'shopId'(val) {
                this.getDetail()
            }
        }
    };
</script>
<style lang="scss">
    .restrict {
        min-height: 55vh;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        &-table {
            border-radius: 4px;
            overflow: hidden;
            border: 1px solid #e8e8e8;
            border-right: 0;
            border-bottom: 0;
        }
        .ant-table-bordered .ant-table-body > table {
            border: 0;
        }
        .limitNum{
            width: 117px;
        }
    }
</style>